import {BlankResponseType, BlankType} from "@/models/blanksInput.model";

export interface QuizModel {
  id: number,
  hideAnswers: boolean,
  nbChosenQuestions: number,
  nbQuestions: number,
  nbTry: number,
  questions?: QuizQuestionModel[],
  randomMode: boolean,
  reference?: string,
  scoreToContinue: number,
  timer: string,
  quizType: QuizType,
}

export interface QuizQuestionModel {
  answers?: QuizAnswerModel[],
  correction?: string,
  id: number,
  questionRef: string,
  information?: string,
  label?: string
  order: number,
  type: QuizQuestionType,
  blanksText: string;
  blanks: QuizQuestionBlank[];
  matchingPairs: QuizQuestionMatchingPair[];
  sortingItems: QuizQuestionSortingItem[];
}

export interface QuizAnswerModel {
  id: number,
  label?: string,
  rightAnswer: boolean,
  image: QuizAnswerImageModel
}

export interface QuizAnswerImageModel {
  imageName: string,
  imageLabel?: string,
  imagePath?: string,
  smallImagePath?: string,
  uploadTmpPath?: string,
}

export interface QuizUserResponses {
  contenuQuizId: number;
  percentage?: number;
  questions: QuizQuestionUserAnswers[];
}

export interface QuizQuestionUserAnswers {
  questionId: number,
  questionType: QuizQuestionType,
  order: number,
  blanksText: string,
  responsesIds: number[] | null
  responseContent: string | null;
  blanksResponses?: QuizQuestionUserBlankAnswer[];
  pairsMatching?: QuizQuestionUserPairMatching[];
  itemsSorting?: QuizQuestionUserItemSorting[];
}

export interface PollQuizStatisticsData {
  id: number;
  questionLabel: string;
  questionInformation: string;
  questionType: QuizQuestionType;
  responsesStats: PollQuizResponseStat[] | null;
}

export interface PollQuizResponseStat {
  responseId: number;
  responseLabel: string;
  nbVotes: number;
  votesPercentage: number;
}

export enum QuizQuestionType {
  QUESTION_CHOIX_MULTIPLE = "QUESTION_CHOIX_MULTIPLE",
  QUESTION_CHOIX_UNIQUE = "QUESTION_CHOIX_UNIQUE",
  QUESTION_VRAI_FAUX = "QUESTION_VRAI_FAUX",
  QUESTION_TEXTE = "QUESTION_TEXTE",
  QUESTION_PARAGRAPHE = "QUESTION_PARAGRAPHE",
  QUESTION_FILL_IN_THE_BLANKS = "QUESTION_FILL_IN_THE_BLANKS",
  QUESTION_MATCHING = "QUESTION_MATCHING",
  QUESTION_SORTING = "QUESTION_SORTING",
}

export enum QuizResultState {
  QUIZZ_TERMINE = "QUIZZ_TERMINE",
  QUIZZ_EN_COURS = "QUIZZ_EN_COURS",
  QUIZZ_A_VALIDER = "QUIZZ_A_VALIDER"
}

export enum QuizType {
  QUIZZ_EXAMEN = "QUIZZ_EXAMEN",
  QUESTION_OUVERTE = "QUESTION_OUVERTE",
  SONDAGE = "SONDAGE",
  ENQUETE = "ENQUETE"
}

export enum ExamQuizPlayerStep {
  PREAMBLE = "PREAMBLE",
  STARTED = "STARTED",
  COMPLETED = "COMPLETED",
  TERMINATED = "TERMINATED"
}

export interface ExamQuizUserRealtimeData {
  successRate: number;
  remaningTries: number;
  overallAnswers: QuizUserResponses | null;
  currentQuestionRealtimeAnswers: QuizQuestionUserAnswers | null;
  timeElapsed: boolean;
  currentSlideIndex: number;
}

export interface UserOverallQuizzesResults {
  idAchatCour: number;
  speachID: string;
  userName: string;
  speachTitle: string;
  quizzesResults: UserQuizResults[];
}

export interface UserQuizResults {
  quizResultsId: number;
  chapterName: string;
  quiz: QuizModel;
  quizResultState: QuizResultState;
  quizResultDate: string;
  questions: QuizQuestionUserAnswers[];
  quizResultHtml: string;
  remainingTries: number;
  percentage: number;
}

export interface QuizQuestionBlank {
  id: number;
  position: number;
  type: BlankType;
  responses: QuizQuestionBlankResponse[];
}

export interface QuizQuestionMatchingPair {
  id: number;
  position: number;
  item: string;
  itemResponse: string;
  itemImage: QuizAnswerImageModel;
  itemResponseImage: QuizAnswerImageModel;
}

export interface QuizQuestionSortingItem {
  id: number;
  position: number;
  value: string;
  image: QuizAnswerImageModel;
}

export interface QuizQuestionUserPairMatching {
  itemId: number;
  responseRelatedItemId?: number;
}

export interface QuizQuestionUserItemSorting {
  itemId: number;
  position: number;
}

export interface QuizQuestionBlankResponse {
  blankResponseId: number;
  label: string;
  type: BlankResponseType;
  correctAnswer: boolean;
  caseSensitive: boolean;
  image: QuizAnswerImageModel;
}

export interface QuizQuestionUserBlankAnswer {
  blankId: number;
  position: number;
  type: BlankResponseType;
  responseOptionId: number | null;
  responseOptionLabel: string;
  textResponse: string;
}

export interface QuizResponseSelectOption {
  value: string;
  label: string;
  htmlLabel: string;
  htmlContent: string;
  disabled?: boolean;
}

export interface QuizResponseDropdownItem {
  pair: QuizQuestionMatchingPair;
  disabled?: boolean;
}
